import { ReactNode } from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';
import {
  DarwinCheckbox,
  DarwinDivider,
  DarwinFlex,
  DarwinTooltip,
} from 'components/darwin-ui';
import Icon from 'components/darwin-ui/Icon';
import styles from './index.module.css';

interface EudrSectionShellProps {
  title: string;
  subtitle?: string;
  /** Small descriptive text shown below the checkbox row */
  description?: string;
  checked: boolean;
  onCheckChange: (checked: boolean) => void;
  checkboxLabel: string;
  checkboxTooltip: string;
  checkboxDisabled?: boolean;
  /** Extra content rendered on the right side of the checkbox row */
  checkboxExtra?: ReactNode;
  /** Content shown below the checkbox row when checked */
  children?: ReactNode;
}

export const EudrSectionShell = ({
  title,
  subtitle,
  description,
  checked,
  onCheckChange,
  checkboxLabel,
  checkboxTooltip,
  checkboxDisabled,
  checkboxExtra,
  children,
}: EudrSectionShellProps) => {
  return (
    <DarwinFlex className={styles.contentContainer} vertical>
      <DarwinFlex className={styles.titleContainer}>
        <Icon name="tree" className={styles.titleIcon} size="lg" />
        <DarwinFlex vertical>
          <span className={styles.title}>{title}</span>
          {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
        </DarwinFlex>
      </DarwinFlex>

      <DarwinDivider style={{ margin: 0 }} />

      <DarwinFlex className={styles.checkboxRow}>
        <DarwinFlex className={styles.checkboxContainer}>
          <DarwinCheckbox
            checked={checked}
            onChange={e => onCheckChange(e.target.checked)}
            disabled={checkboxDisabled}
          >
            <span className={styles.checkboxLabel}>{checkboxLabel}</span>
          </DarwinCheckbox>
          <DarwinTooltip title={checkboxTooltip}>
            <InfoCircleOutlined aria-label="EUDR info" />
          </DarwinTooltip>
        </DarwinFlex>
        {checkboxExtra}
      </DarwinFlex>

      {description && <span className={styles.description}>{description}</span>}

      {checked && children}
    </DarwinFlex>
  );
};
